import { render, staticRenderFns } from "./remit.vue?vue&type=template&id=9217e9cc&scoped=true&"
import script from "./remit.vue?vue&type=script&lang=js&"
export * from "./remit.vue?vue&type=script&lang=js&"
import style0 from "./remit.vue?vue&type=style&index=0&id=9217e9cc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9217e9cc",
  null
  
)

export default component.exports